module.exports = __webpack_public_path__ + "static/media/iconDelete.1d01d745.svg";